import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { Settings } from 'luxon';

Settings.defaultLocale = 'fr';

export function checkPreLoader() {
  const logo = document.getElementById('logo') as any;
  const preLogo = document.getElementById('pre-logo') as any;
  const pre = document.getElementById('pre') as any;
  if (logo && pre && preLogo) {
    pre.className = 'loaded';
    const rect = logo.getBoundingClientRect();
    preLogo.style.top = rect.top + logo.offsetHeight / 2 + 'px';
    preLogo.style.left = rect.left + logo.offsetWidth / 2 + 'px';
    preLogo.style.width = logo.offsetWidth + 'px';
  } else {
    setTimeout(checkPreLoader, 500);
  }
}

if (environment.production) {
  enableProdMode();
}

checkPreLoader();
platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));
